import styled from "styled-components";
import {TileButton} from "./PageThemeSection.styles";

/**
 * Externalized styles for {@link ./TileDeleteButton}.
 *
 * Tinted rather than filled, unlike the overlaid {@link ./TileRemoveButton}: this one sits in the
 * control row of an UNSELECTED tile against a card surface, where `errorInk` is the per-mode red that
 * stays legible.
 */
export const Root = styled(TileButton)`
	color: ${({theme}) => theme.tokens.errorInk};

	&:hover:not(:disabled) {
		border-color: ${({theme}) => theme.tokens.errorInk};
		color: ${({theme}) => theme.tokens.errorInk};
	}
`;
